module.exports = __webpack_public_path__ + "static/media/milleniumfalcon.dac7afbe.png";